// seatMotion — a held seat pose that moves a little (2026-10-31).
//
// SeatCamera holds you exactly at the seat while you are in it. Running on a
// treadmill is "in" a pose that still moves: the stride bounces your eye. Rather
// than a second component fighting SeatCamera for the camera every frame (and
// winning or losing by mount order), whoever owns the equipment sets ONE function
// here and SeatCamera adds its offset to the hold.
//
//   seatMotion.fn = (seconds, target) => [dx, dy, dz] | null
//
// Plain module state like interiorFloor: it changes when you step on or off,
// and nothing needs to re-render for it.
export const seatMotion = { fn: null };
